export default __webpack_public_path__ + "static/media/icon-arrow-right.1205c5ec.svg";